import { confirmAlert as reactConfirmAlert } from 'react-confirm-alert';
import { Container, Button, Row, Col, Card, CardBody, CardTitle } from 'reactstrap';

type ClassAlertProps = {
  title: string;
  messageType: string;
  id?: string;
  message?: string;
  onClickYes: (param?: any) => void;
  label?: string;
};

const confirmAlert = ({ title, messageType, id, message, onClickYes, label }: ClassAlertProps) => {
  const validMessageTypes = [
    { messageType: 'SAVE', text: 'save' },
    { messageType: 'EDIT', text: 'edit' },
    { messageType: 'DELETE', text: 'delete' },
  ];
  const alertMessageType = `${validMessageTypes.find((m) => m.messageType === messageType)?.text || 'save'}`;
  const itemName = `'${label ? label : id ? id : ''}'`;
  const alertMessage = message ? message : `Are you sure to ${alertMessageType} item ${itemName}?`;

  return reactConfirmAlert({
    customUI: ({ onClose }) => {
      return (
        <Container fluid>
          <Card>
            <CardBody>
              <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                {title}
              </CardTitle>
              <Row className="mt-3">
                <Col md="12 text-center">
                  <span className="h2 font-weight-bold mb-0">{alertMessage}</span>
                </Col>
              </Row>
              <Row className="mt-5">
                <Col md="6 text-center" xs="6">
                  <Button
                    color="primary"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      onClickYes(id);
                      onClose();
                    }}
                    size="lg"
                    style={{ minWidth: '100px' }}
                  >
                    Yes
                  </Button>
                </Col>
                <Col md="6 text-center" xs="6">
                  <Button
                    color="danger"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      onClose();
                    }}
                    size="lg"
                    style={{ minWidth: '100px' }}
                  >
                    No
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      );
    },
  });
};

export default confirmAlert;
